import React, { Component } from 'react';
import { FormattedMessage } from "react-intl";
import authService from '../api-authorization/AuthorizeService'
import { OrderRemarkDialog } from './OrderRemarkDialog';

export class OrderRemarkButton extends Component {
    constructor(props) {
        super(props);
        this.state = { show: false, isAllow: true };
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }
    async componentDidMount() {
        //if (this.props.module && this.props.action) {
        //    const isAllow = await authService.isAllow(this.props.module, this.props.action);
        //    //console.log(isAllow);
        //    this.setState({
        //        isAllow: isAllow
        //    });
        //}
    }
    onSubmit(remark) {
        this.setState({ show: false });
        var handler = this.props.onSubmit;
        if (handler) {
            handler(remark);
        }
    }

    onClose() {
        this.setState({ show: false });
    }

    handleButtonClick(e) {
        this.setState({ show: true });
    }

    render() {        
        return this.state.isAllow && (         
            <button onClick={this.handleButtonClick} className="inline-block mx-2 justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                <FormattedMessage id="OrderRemark" />
                <OrderRemarkDialog orderId={this.props.orderId} remark={this.props.remark} show={this.state.show} onClose={this.onClose} onSubmit={this.onSubmit} />
            </button>                      
        );
    }
}

